import { useState, type FormEvent } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ApiError, errorMessage } from '../api/client';
import { useAuthMutations } from '../api/hooks';
import { AuthFrame } from '../components/AuthFrame';
import { Field } from '../components/Field';
import { de } from '../i18n/de';

/** Öffentliche Seite: Link anfordern (ohne Token) bzw. neues Passwort setzen (`?token=…`). */
export function ResetPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const { requestReset, confirmReset } = useAuthMutations();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const request = (e: FormEvent): void => {
    e.preventDefault();
    requestReset.mutate(email);
  };
  const confirm = (e: FormEvent): void => {
    e.preventDefault();
    if (token) confirmReset.mutate({ token, password });
  };

  return (
    <AuthFrame title={de.auth.resetTitle}>
      {!token ? (
        requestReset.isSuccess ? (
          <div className="notice ok" role="status">
            {de.auth.resetSent}
          </div>
        ) : (
          <form className="col" onSubmit={request}>
            <div className="muted">{de.auth.resetIntro}</div>
            <Field label={de.auth.email}>
              <input type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
            </Field>
            {requestReset.isError && <div className="error-text">{errorMessage(requestReset.error)}</div>}
            <button className="btn primary" type="submit" disabled={requestReset.isPending}>
              {de.auth.resetSend}
            </button>
          </form>
        )
      ) : confirmReset.isSuccess ? (
        <div className="notice ok" role="status">
          {de.auth.resetDone}
        </div>
      ) : (
        <form className="col" onSubmit={confirm}>
          <Field label={de.auth.resetNewPassword} help={de.auth.passwordHint}>
            <input type="password" required minLength={10} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus />
          </Field>
          {confirmReset.isError && (
            <div className="error-text" role="alert">
              {confirmReset.error instanceof ApiError && confirmReset.error.status === 400 && confirmReset.error.message.includes('Link') ? de.auth.resetInvalid : errorMessage(confirmReset.error)}
            </div>
          )}
          <button className="btn primary" type="submit" disabled={confirmReset.isPending}>
            {de.auth.resetSave}
          </button>
        </form>
      )}
      <div className="auth-links">
        <Link to="/login">{de.auth.backToLogin}</Link>
      </div>
    </AuthFrame>
  );
}
